export const KIT_LIMIT = 3;
export const HIGH_MAX = 10000;
export const LOW_MAX_DEFAULT = 499;
export const MEDIUM_MAX_DEFAULT = 999;
export const HIGH_MIN_DEFAULT = 1000;
